import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CTAButtonProps = {
  label: string;
  id?: string;
  className?: string;
};
export function CTAButton({
  label,
  id,
  className = ""
}: CTAButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center text-[17px] font-extrabold uppercase leading-snug tracking-wide text-white shadow-[0_10px_30px_-8px_rgba(22,163,74,0.6)] transition-[transform,background-color] duration-150 ease-out hover:bg-cta-dark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 md:text-xl ${className}`} data-id="element-27" data-mp="2kwbpdyth92hr">
      <span data-id="element-28" data-mp="2yqutqfszeg2p">{label}</span>
      <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-29" data-mp="3cpu72rb1n8jk" />
    </a>;
}